export enum ChallengeTypes {
  Personal = 0,
  Team = 1,
  DailyGame = 2,
}
